import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default Route.extend({
  store: service(),

  model() {
    let groupModel = this.modelFor('funds.fund.groups.group');
    let record = this.store.createRecord('edit-group', {
      action: 'delete',
      name: groupModel.group,
    });
    return Object.assign({}, groupModel, {
      record,
    });
  },
});
